import { OktaAuth, type OktaAuthOptions } from "@okta/okta-auth-js";

const oktaIssuer = import.meta.env.VITE_OKTA_ISSUER;
const oktaClientId = import.meta.env.VITE_OKTA_CLIENT_ID;
const oktaScopesRaw = import.meta.env.VITE_OKTA_SCOPES;

if (!oktaIssuer || !oktaClientId) {
  console.warn(
    "[oktaConfig] Missing VITE_OKTA_ISSUER or VITE_OKTA_CLIENT_ID. Auth will fail.",
  );
}

export const oktaScopes: string[] = oktaScopesRaw
  ? oktaScopesRaw.split(/\s+/).filter(Boolean)
  : ["openid", "profile", "email", "brieftaker.read", "brieftaker.write"];

const config: OktaAuthOptions = {
  issuer: oktaIssuer,
  clientId: oktaClientId,
  redirectUri: `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: window.location.origin,
  scopes: oktaScopes,
  pkce: true,
  responseType: "code",
  tokenManager: {
    autoRenew: true,
    storage: "sessionStorage",
  },
};

export const oktaAuth = new OktaAuth(config);
